import React from 'react';
import Image from 'next/image';
import { PLATFORMS } from '@/shared/constants/existing-brands';
import Link from 'next/link';
import './index.less';

const MarketingTools = () => {
  return (
    <div className="marketing-tools">
      <div className="marketing-tools-container">
        <div className="header">
          <h1>
            <span>Save on</span> marketing tools with your membership
          </h1>
          <p>Stop overpaying for email capture and influencer management tools.</p>
        </div>
        <div className="platform-container">
          {PLATFORMS.map(({ title, description, logo: { link, width, height }, linkTo, style, cardStyle }) => (
            <div key={`${title} ${link}`} className={`platform-card-container ${linkTo}`} style={cardStyle}>
              <Link href={`/platform/${linkTo}`}>
                <div style={style} className={`platform-card`}>
                  <div className="header">
                    <h1>{title}</h1>
                    <p>{description}</p>
                  </div>
                  <Image width={width} height={height} src={link} alt={title} />
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarketingTools;
